export default "__VITE_ASSET__e8801f99__"